import { FolkSpaceRadial } from '../folk-space-radial';
FolkSpaceRadial.define();
export { FolkSpaceRadial };
//# sourceMappingURL=folk-space-radial.js.map